import { Token } from '@kb3d/models/classes/token';
import { FeatureRenderer } from './feature';
import { MergePolygonsFeature } from '@kb3d/models/classes/features/merge-polygons-feature';
import { MergePolygonsGeometryProcessor } from './geometry-processor/merge-polygons-geometry';

export class MergePolygonsRenderer extends FeatureRenderer<MergePolygonsFeature> {
    modelToken = Token.MergePolygonsFeature;
    processor = new MergePolygonsGeometryProcessor(this.scene);

    update3dInternal() {}
}
